export function delayed<T>(promise: Promise<T>, delayMs = 500): Promise<T> {
  const delayPromise = new Promise((resolve) => {
    setTimeout(resolve, delayMs)
  })
  return Promise.all([delayPromise, promise]).then((results) => results[1])
}
